// Auto-generated by tools/build/write-build-release.mjs
// Do not edit manually.
export const BUILD_RELEASE_TOKEN = "release:1789746125641:prod:bt2qy18z";
export const BUILD_RELEASE_CREATED_AT = "2026-09-18T15:42:05.641Z";
